import {useEffect, useState} from 'react';

import PubSwitcher from 'components/PubSwitcher/PubSwitcher';
import BeersManager from 'features/beersManager/BeersManager';
import {beerManagerModes} from 'features/beersManager/typescript';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import './BeersManager.scss';
import {setNavigationTitleAC} from 'store/app/appSlice';

import NavbarItems from './NavbarItems/NavbarItems';

const BeersManagerPage = () => {
  const dispatch = useSetGlobalState();
  const {mode} = useGlobalState((state) => state.beersManager);
  const {user} = useGlobalState((state) => state.app);
  const [showPubSwitcher, setShowPubSwitcher] = useState(false);

  const isSelectingBeers = mode === beerManagerModes.addBeers;

  useEffect(() => {
    dispatch(setNavigationTitleAC('beers on tap'));
    // eslint-disable-next-line
  }, []);

  return (
    <LayoutPage
      className={`beers-manager-page ${isSelectingBeers ? 'beers-manager-page--disable-sidebar' : ''}   ${
        showPubSwitcher ? 'layout-page--disable-toggler' : ''
      }`}
      navbarChildren={<NavbarItems isSelectingBeers={isSelectingBeers} setShowPubSwitcher={setShowPubSwitcher} />}
    >
      {showPubSwitcher && <PubSwitcher onClose={() => setShowPubSwitcher(false)} pubs={user?.attributes.pubs || []} />}
      <BeersManager />
    </LayoutPage>
  );
};

export default BeersManagerPage;
